module.exports = __webpack_public_path__ + "staticcomp/img/cover.3e25c5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/3/cover.jpg
// module id = cDuX
// module chunks = 39